namespace Matrix.Scheduling {
    export interface CalendarBaseRow {
        CalendarCode?: string;
        BaseCalendarCode?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        CalendarCodeName?: string;
        CalendarCodeRowId?: number;
        BaseCalendarCodeName?: string;
        BaseCalendarCodeRowId?: number;
    }

    export namespace CalendarBaseRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'CalendarCode';
        export const localTextPrefix = 'Scheduling.CalendarBase';
        export const deletePermission = 'DataAdmin:Calendar';
        export const insertPermission = 'DataAdmin:Calendar';
        export const readPermission = 'Read:Calendar';
        export const updatePermission = 'DataAdmin:Calendar';

        export declare const enum Fields {
            CalendarCode = "CalendarCode",
            BaseCalendarCode = "BaseCalendarCode",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            CalendarCodeName = "CalendarCodeName",
            CalendarCodeRowId = "CalendarCodeRowId",
            BaseCalendarCodeName = "BaseCalendarCodeName",
            BaseCalendarCodeRowId = "BaseCalendarCodeRowId"
        }
    }
}
